export const CustomReactSelectStyles = (isDarkMode: boolean) => ({
  control: (styles: any, state: any) => ({
    ...styles,
    backgroundColor: isDarkMode ? '#262A2F' : '#fff', // Dark mode or light mode background
    borderColor: state.isFocused
      ? isDarkMode
        ? '#fff' // White border on focus in dark mode
        : '#b0c4de' // Light blue border on focus in light mode
      : isDarkMode
      ? '#262A2F' // Default border color in dark mode
      : '#ddd', // Default border color in light mode
    boxShadow: state.isFocused
      ? isDarkMode
        ? '0 0 5px rgba(255, 255, 255, 0.5)' // White shadow on focus in dark mode
        : '0 0 5px rgba(0, 0, 255, 0.2)' // Blue shadow in light mode
      : styles.boxShadow,
    transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      borderColor: isDarkMode ? '#fff' : '#b0c4de', // White border on hover in dark mode
      boxShadow: isDarkMode
        ? '0 0 5px rgba(255, 255, 255, 0.5)' // White shadow on hover in dark mode
        : '0 0 5px rgba(0, 0, 255, 0.2)', // Blue shadow in light mode
    },
    outline: 'none',
  }),
  placeholder: (styles: any) => ({
    ...styles,
    color: '#878A99', // Customize placeholder color
  }),
  singleValue: (styles: any) => ({
    ...styles,
    color: isDarkMode ? '#fff' : '#333', // White text in dark mode, dark text in light mode
  }),
  option: (styles: any, state: any) => ({
    ...styles,
    backgroundColor: state.isSelected
      ? isDarkMode
        ? '#4bb189'
        : '#4bb189'
      : state.isFocused
      ? isDarkMode
        ? '#4bb18980'
        : '#4bb18980'
      : 'transparent',
    color: state.isSelected ? '#fff' : isDarkMode ? '#ffffff' : '#000000',
    padding: 10,
    ':hover': {
      backgroundColor: isDarkMode ? '#4bb189' : '#4bb189',
      color: '#fff',
    },
  }),
});
